import type { NFOut, NFSeverity, PdfMetaNF } from '../types/api';

/** Tolerância de data (dias) para colorir o diff na tabela de conferência.
 *  Fonte da regra é o backend (services/nf_conferencia.py); aqui é só apresentação. */
export const CONFERENCIA_DATE_TOLERANCE_DAYS = 1;

/** Fatura extraída do PDF (parse segue no navegador); enviada ao backend para conferência. */
export interface FaturaNF {
  n: number;
  vencimento: string;
  valor: number;
  nfNumero?: string;
}

/** Boleto real informado manualmente para uma parcela. */
export interface BoletoReal {
  data?: string;
  valor?: number | string;
}

export function readBoletosReais(pdfMeta: Pick<PdfMetaNF, 'boletosReais'> | null | undefined): BoletoReal[] {
  const raw = pdfMeta?.boletosReais;
  return Array.isArray(raw) ? (raw as BoletoReal[]) : [];
}

/**
 * Severidade de uma NF a partir dos campos JÁ CALCULADOS pelo backend
 * (`divergencias` e `pdf_meta.statusConferencia`). Não recalcula nada.
 */
export function nfSeverity(nf: NFOut): NFSeverity {
  if (nf.tipo_nf === 'bonificacao') return 'bonificacao';
  const status = nf.pdf_meta?.statusConferencia;
  if (status === 'pendente' || status === 'divergente' || status === 'conferido') return status;
  if (!nf.pedido_id) return 'pendente';
  const high = nf.divergencias.some(d => String(d.sev ?? '') === 'alta');
  return high ? 'divergente' : 'conferido';
}
